export const oldUrlAndNewurl = [
    {
        old:'/apartments-in-kochi/',
        new:'/apartments-for-sale-in-kochi'
    },
    {
        old:'/blog/?p=1715',
        new:'/blogs'
    },
    {
        old:'/video-testimonials/',
        new:'/key-handover'
    },
    {
        old:'/residential-property-in-kochi/tata-tritvam',
        new:'/apartments-for-sale-in-kochi'
    },{
        old:'/noreferrer',
        new:'/contact'
    },{
        old:'/news-events',
        new:'/events'
    },
    {
        old:'/classic-utsav-2018',
        new:'/events'
    },{
        old:'/flats-in-kochi/',
        new:'/blog/kochi-flats-where-convenience-meets-comfort'
    },{
        old:'/classic-sunny-sands/',
        new:'/villas-for-sale-in-kochi'
    },

]